import { CustomerPurchaseListParams } from "@/models/club";
import customerService from "@/services/customer";
import { useQuery } from "@tanstack/react-query";

type Props = {
  params: CustomerPurchaseListParams;
};

const useGetInvoices = ({ params }: Props) =>
  useQuery({
    queryKey: ["invoices", params],
    queryFn: () => customerService.getInvoices(params),
    keepPreviousData: true,
  });

export default useGetInvoices;
